import script from "./FtpSettingsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./FtpSettingsView.vue?vue&type=script&setup=true&lang=ts"

import "./FtpSettingsView.vue?vue&type=style&index=0&id=6e740784&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e740784"]])

export default __exports__